

import { NavBar } from './navbar';
import { NavbarSearchWidget } from './widgets/navbar-search-widget';
import { NavbarSearchWidgetStatic } from './widgets/navbar-search-widget-static';
import { NavbarLoginWidget } from './widgets/navbar-login-widget';
import { NavBarLinksWidget } from './widgets/navbar-links-widget';
import { NavbarLangSwitchWidget } from './widgets/navbar-lang-switch-widget';
import { NavbarProjectsWidget } from './widgets/navbar-projects-widget';
import { NavbarIconWidget } from './widgets/navbar-icon-widget';

export { NavBar };

export const NavbarWidget = {
    Search: NavbarSearchWidget,
    SearchStatic: NavbarSearchWidgetStatic,
    Login: NavbarLoginWidget,
    Links: NavBarLinksWidget,
    LangSwitch: NavbarLangSwitchWidget,
    Projects: NavbarProjectsWidget,
    Icon: NavbarIconWidget,
};


import { NavBar } from './navbar';
import { NavbarSearchWidget } from './widgets/navbar-search-widget';
import { NavbarSearchWidgetStatic } from './widgets/navbar-search-widget-static';
import { NavbarLoginWidget } from './widgets/navbar-login-widget';
import { NavBarLinksWidget } from './widgets/navbar-links-widget';
import { NavbarLangSwitchWidget } from './widgets/navbar-lang-switch-widget';
import { NavbarProjectsWidget } from './widgets/navbar-projects-widget';
import { NavbarIconWidget } from './widgets/navbar-icon-widget';

export { NavBar };

export const NavbarWidget = {
    Search: NavbarSearchWidget,
    SearchStatic: NavbarSearchWidgetStatic,
    Login: NavbarLoginWidget,
    Links: NavBarLinksWidget,
    LangSwitch: NavbarLangSwitchWidget,
    Projects: NavbarProjectsWidget,
    Icon: NavbarIconWidget,
};
